import {Card, Image} from 'antd';
import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import ReadMore from 'read-more-react';
import {ConditionalWrapper, itoh} from 'src/utils';
import styles from './Artist.module.scss';

export enum ArtistSize {
  Small,
}

type ArtistProps = {
  id?: string | null;
  name?: string | null;
  imageUri?: string | null;
  description?: string | null;
  size?: ArtistSize;
  selected?: boolean;
  children?: ReactNode;
};

export default function Artist(props: ArtistProps) {
  return (
    <div className={props.selected ? styles.selected : ''}>
      <Card
        size='small'
        cover={
          <Image
            placeholder
            fallback={process.env.PUBLIC_URL + '/missing.jpg'}
            alt={props.name || 'artist'}
            src={itoh(props.imageUri)}
          />
        }>
        {props.size === ArtistSize.Small ? (
          props.name
        ) : (
          <Card.Meta
            title={
              <ConditionalWrapper
                wrap={!!props.id}
                wrapper={(c) => (
                  <Link className='plainLink' to={`/artists/${props.id}`}>
                    {c}
                  </Link>
                )}>
                {props.name}
              </ConditionalWrapper>
            }
            description={
              <div className={styles.description}>
                <ReadMore text={props.description || ''} readMoreText='&nbsp;Read more' />
              </div>
            }
          />
        )}
        {props.children}
      </Card>
    </div>
  );
}
